import EmployeesRepositoryImpl from './EmployeesRepositoryImpl';
import { fetcherAmplify } from 'src/business/Libraries/Fetcher';

const employeesRepositoryImpl = new EmployeesRepositoryImpl(fetcherAmplify);

export { employeesRepositoryImpl };
